import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Vehicle } from "@/interface/entityInterface"
import { Car } from "lucide-react"
import { FC } from "react"

interface Props {
    vehicle: Vehicle
}

const VehicleCard: FC<Props> = ({vehicle}) => {
    return (
        <div className="flex items-center gap-3">
            <img
                src={vehicle.make.logo}
                alt={vehicle.make.name}
                className="w-8 h-8 object-contain invert dark:invert-0"
            />
            <div>
                <p className="font-semibold">
                {vehicle.make.name} ({vehicle.make_year})
                </p>
                <p className="text-sm text-muted-foreground">
                {vehicle.nickname || ""} • {vehicle.license_plate}
                </p>
            </div>
        </div>
    )
}

export default VehicleCard